import { Link } from 'react-router-dom'
import { bgPhoto } from '../utils/img'
import ScrollReveal from './ScrollReveal'
import './ServiceCard.css'

export default function ServiceCard({ service, delay = 0 }) {
  return (
    <ScrollReveal delay={delay} className="service-card card">
      <div
        className="service-card-media"
        style={{ backgroundImage: `url(${bgPhoto(service.image, 700, 560)})` }}
      >
        <span className="service-card-number">{service.number}</span>
      </div>
      <div className="service-card-body">
        <h3>{service.name}</h3>
        <p>{service.short}</p>
        <Link to={`/services#${service.id}`} className="service-card-link">
          Explore <span aria-hidden="true">&rarr;</span>
        </Link>
      </div>
    </ScrollReveal>
  )
}
